var map = {
	"./IMG_1552.PNG": 677,
	"./IMG_1553.PNG": 652,
	"./IMG_1557.PNG": 32,
	"./background.jpg": 772,
	"./chatterblock.png": 913,
	"./cheekymonkey.png": 167,
	"./dwave.svg": 292,
	"./pela.png": 875,
	"./reset.svg": 622,
	"./uvic.png": 646
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 603;